<div
  class="navbar fixed-top p-0"
  style="background-color: #0071cd"
>
  <div class="container">
    <div class="navbar-brand">
      <img src="/dist/browser/images//AutolandLogo.jpg" />
    </div>
    <div class="navbar-right">
      <a
        class="text-white"
        href="#"
        (click)="logOut()"
        ><span
          class="glyphicon glyphicon-log-out"
          aria-hidden="true"
        ></span
        >log out</a
      >

      <ul class="nav navbar-nav"></ul>
    </div>
  </div>
</div>

@if(dto != null){
<div
  class="container"
  style="margin-top: 80px"
  id="index"
>
  <div class="card border-1 p-2">
    <div class="card-header">
      <h5>Referring your members to Autoland for a great car buying experience is easy!</h5>
      <p>Just complete the below information and click Submit.</p>
      <div
        class="alert alert-success"
        role="alert"
        [hidden]="!formSubmittedSuccessfully"
      >
        <h4>Your member has been successfully submitted! Thank you!</h4>
        <a
          href="/"
          [ngClass]="'btn btn-primary'"
          role="button"
          >Submit another member</a
        >
      </div>
    </div>
    <div class="card-body">
      <form
        [formGroup]="leadForm"
        class="needs-validation"
        (ngSubmit)="onLeadSubmit()"
        [hidden]="formSubmittedSuccessfully"
      >
        <div class="w-100"
             id="leadInfo">
          <section class="w-100">
            <content class="row row-cols-2 justify-content-sm-between justify-content-md-start">
              <div class="col-auto col-md-2 legend">Credit Union</div>
              <div class="col-7">
                {{ dto.affinityGroupName }}
              </div>
            </content>
            <content class="row row-cols-2 justify-content-sm-between justify-content-md-start">
              <div class="col-auto col-md-2 legend">Branch</div>
              <div class="col-7 col-md-4">
                <app-formselect [a-validation-messages]="[
                    { validationName: 'required', validationMessage: 'Branch is required' }
                  ]"
                                [a-formcontrol]="leadForm.controls.branchId"
                                [a-formcontrol-name]="'branchId'">
                  <option [value]="0">Select a branch</option>
                  @for(item of dto.branches; track item.id){
                  <option [value]="item.id">{{ item.label }}</option>
                  }
                </app-formselect>
              </div>
            </content>

            <content class="row row-cols-2 justify-content-sm-between justify-content-md-start">
              <div class="col-auto col-md-2 legend">Employee</div>
              <div class="col-7 col-md-4">
                <app-formselect [a-formcontrol]="leadForm.controls.employeeId"
                                [a-formcontrol-name]="'employeeId'"
                                [a-validation-messages]="[
                    { validationName: 'required', validationMessage: 'Employee is required' }
                  ]">
                  <option [value]="0">Select an employee</option>
                  @for(item of dto.employees; track item.id){
                  <option [value]="item.id">{{ item.displayName }}</option>
                  }
                </app-formselect>
              </div>
            </content>

            <div class="checkbox col-12">
              <input type="checkbox"
                     [disabled]="leadForm.controls.branchId.invalid"
                     formControlName="employeeNotListed"
                     class="" />
              Employee Not listed (branch must be selected)
            </div>
            @if(leadForm.controls.employeeNotListed.value && leadForm.controls.branchId.valid){

            <app-new-employee-form [branch-id]="leadForm.controls.branchId.value"
                                   (form$)="newEmployee$($event)"
                                   [cu-id]="dto.affinityGroupId">
            </app-new-employee-form>
            }
          </section>

          <div class="col-xs-12 legend">
            <hr />
            <h5><b>Member Information</b></h5>
          </div>
          <div class="col-auto"
               *ngIf="leadForm.controls.branchId.invalid || leadForm.controls.employeeId.invalid">
            <div class="alert alert-info">
              Member form will display when all required fields above have been satisifed.

              <ul class="text-danger">
                <li *ngIf="leadForm.get('branchId')?.invalid">Branch selection required</li>
                <li *ngIf="leadForm.get('employeeId')?.invalid">Employee selection required</li>
              </ul>
            </div>
          </div>
          <div [formGroup]="newMemberForm"
               class="needs-validation"
               *ngIf="!leadForm.controls.branchId.invalid && !leadForm.controls.employeeId.invalid">
            <div class="row g-3 mb-3">
              <div class="col-md-4">
                <label for="firstName"
                       class="form-label required">First name <span class="text-danger">*</span></label>
                <app-formcontrol [a-formcontrol]="newMemberForm.controls.firstName"
                                 a-formcontrol-name="firstName"
                                 [a-validation-messages]="[
                    { validationName: 'required', validationMessage: 'Firstname is required' },
                    {
                      validationName: 'pattern',
                      validationMessage:
                        'Firstname is invalid. Special characters, spaces or numbers are not allowed'
                    },
                    {
                      validationName: 'maxlength',
                      validationMessage: 'Firstname cannot be more than 50 characters'
                    }
                  ]"
                                 id="firstName"></app-formcontrol>
              </div>
              <div class="col-md-2">
                <label for="middleName"
                       class="form-label">Middle Initial</label>
                <app-formcontrol [a-formcontrol]="leadForm.controls.newMember.controls.middleName"
                                 a-formcontrol-name="middleName"
                                 [a-validation-messages]="[
                    { validationName: 'required', validationMessage: 'Middlename is required' },
                    {
                      validationName: 'pattern',
                      validationMessage:
                        'Middlename is invalid. Special characters, spaces or numbers are not allowed'
                    },
                    {
                      validationName: 'maxlength',
                      validationMessage: 'Middlename cannot be more than 50 characters'
                    }
                  ]"
                                 id="middleName"></app-formcontrol>
              </div>
              <div class="col-md-3">
                <label for="lastName"
                       class="form-label required">Last name <span class="text-danger">*</span></label>
                <app-formcontrol [a-formcontrol]="leadForm.controls.newMember.controls.lastName"
                                 a-formcontrol-name="lastName"
                                 [a-validation-messages]="[
                    { validationName: 'required', validationMessage: 'Middlename is required' },
                    {
                      validationName: 'pattern',
                      validationMessage:
                        'Middlename is invalid. Special characters, spaces or numbers are not allowed'
                    },
                    {
                      validationName: 'maxlength',
                      validationMessage: 'Middlename cannot be more than 50 characters'
                    }
                  ]"
                                 id="lastName"></app-formcontrol>
              </div>
            </div>

            <div class="row g-3 mb-3">
              <div class="col-md-2">
                <label for="primaryPhone"
                       class="form-label required">Phone (Primary) <span class="text-danger">*</span></label>
                <app-formcontrol [a-formcontrol]="leadForm.controls.newMember.controls.primaryPhone"
                                 a-formcontrol-name="primaryPhone"
                                 [a-validation-messages]="[
                    { validationName: 'required', validationMessage: 'Phone number is required' },
                    {
                      validationName: 'pattern',
                      validationMessage:
                        'Phone number is invalid. Do not include 1 or +1 in front of number'
                    },
                    {
                      validationName: 'maxlength',
                      validationMessage: 'Phone number cannot be more than 50 characters'
                    }
                  ]"
                                 id="primaryPhone"></app-formcontrol>
              </div>
              <div class="col-md-2">
                <label for="secondaryPhone"
                       class="form-label">Phone (Other)</label>
                <app-formcontrol [a-formcontrol]="leadForm.controls.newMember.controls.secondaryPhone"
                                 a-formcontrol-name="secondaryPhone"
                                 [a-validation-messages]="[
                    { validationName: 'required', validationMessage: 'Phone number is required' },
                    {
                      validationName: 'pattern',
                      validationMessage:
                        'Phone number is invalid. Do not include 1 or +1 in front of number'
                    },
                    {
                      validationName: 'maxlength',
                      validationMessage: 'Phone number cannot be more than 50 characters'
                    }
                  ]"
                                 id="secondaryPhone"></app-formcontrol>
              </div>
              <div class="col-md-4">
                <label for="email"
                       class="form-label">Email <span class="text-danger">*</span></label>
                <app-formcontrol [a-formcontrol]="leadForm.controls.newMember.controls.email"
                                 a-formcontrol-name="email"
                                 [a-validation-messages]="[
                    { validationName: 'required', validationMessage: 'Email is required' },
                    {
                      validationName: 'pattern',
                      validationMessage: 'Email is invalid.'
                    },
                    {
                      validationName: 'maxlength',
                      validationMessage: 'Email cannot be more than 50 characters'
                    }
                  ]"
                                 id="email"></app-formcontrol>
              </div>
            </div>

            <div class="row g-3 mb-3">
              <div class="col-md-4">
                <label for="address1"
                       class="form-label">Address <span class="text-danger">*</span></label>
                <app-formcontrol [a-formcontrol]="leadForm.controls.newMember.controls.address"
                                 a-formcontrol-name="address"
                                 [a-validation-messages]="[
                    { validationName: 'required', validationMessage: 'Address is required' },
                    {
                      validationName: 'pattern',
                      validationMessage: 'Address is invalid.'
                    },
                    {
                      validationName: 'maxlength',
                      validationMessage: 'Address cannot be more than 50 characters'
                    }
                  ]"
                                 id="address"></app-formcontrol>
              </div>
              <div class="col-md-4">
                <label for="address2"
                       class="form-label">Apt Or Unit #</label>
                <app-formcontrol [a-formcontrol]="leadForm.controls.newMember.controls.address2"
                                 a-formcontrol-name="address2"
                                 [a-validation-messages]="[
                    { validationName: 'required', validationMessage: 'Address is required' },
                    {
                      validationName: 'pattern',
                      validationMessage: 'Address is invalid.'
                    },
                    {
                      validationName: 'maxlength',
                      validationMessage: 'Address cannot be more than 50 characters'
                    }
                  ]"
                                 id="address2"></app-formcontrol>
              </div>
            </div>
            <div class="row g-3 mb-3">
              <div class="col-md-3">
                <label for="city"
                       class="form-label required">City <span class="text-danger">*</span></label>
                <app-formcontrol [a-formcontrol]="leadForm.controls.newMember.controls.city"
                                 a-formcontrol-name="city"
                                 [a-validation-messages]="[
                    { validationName: 'required', validationMessage: 'City is required' },
                    {
                      validationName: 'pattern',
                      validationMessage: 'City is invalid.'
                    },
                    {
                      validationName: 'maxlength',
                      validationMessage: 'City cannot be more than 50 characters'
                    }
                  ]"
                                 id="city"></app-formcontrol>
              </div>
              <div class="col-md-2">
                <label for="state"
                       class="form-label required">State <span class="text-danger">*</span></label>
                <app-formselect [a-formcontrol]="leadForm.controls.newMember.controls.state"
                                a-formcontrol-name="state"
                                [a-validation-messages]="[
                    { validationName: 'required', validationMessage: 'State is required' },

                  ]">
                  <option [value]="">Select a State</option>
                  @for(item of dto.states; track item){
                  <option [value]="item.id">{{ item.label }}</option>
                  }
                </app-formselect>
              </div>
              <div class="col-md-2">
                <label for="zipCode"
                       class="form-label required">Zip code <span class="text-danger">*</span></label>
                <app-formcontrol [a-formcontrol]="leadForm.controls.newMember.controls.zipCode"
                                 a-formcontrol-name="zipCode"
                                 [a-validation-messages]="[
                    { validationName: 'required', validationMessage: 'Zipcode is required' },
                    {
                      validationName: 'pattern',
                      validationMessage: 'Zipcode is invalid.'
                    },
                    {
                      validationName: 'maxlength',
                      validationMessage: 'Zipcode cannot be more than 12 characters'
                    }
                  ]"
                                 id="zipCode"></app-formcontrol>
              </div>
              <app-address-modal></app-address-modal>
            </div>

            <div class="row g-3 mb-3">
              <div class="col-md-6">
                <label class="form-label required">Pre-Approved</label>
                <div class="d-flex">
                  <div class="form-check me-4">
                    <input formControlName="isPreApproved"
                           class="form-check-input"
                           type="radio"
                           id="preApprovedYes"
                           [value]="true" />
                    <label class="form-check-label"
                           for="preApprovedYes">Yes</label>
                  </div>
                  <div class="form-check">
                    <input formControlName="isPreApproved"
                           class="form-check-input"
                           type="radio"
                           id="preApprovedNo"
                           [value]="false" />
                    <label class="form-check-label"
                           for="preApprovedNo">No</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-6 col-lg-2" *ngIf="newMemberForm.controls.isPreApproved.value === true">
                <label class="form-label">Pre-Approved Amount</label>
                <app-formcontrol [a-formcontrol]="leadForm.controls.newMember.controls.preApprovedAmount"
                                 a-formcontrol-name="preApprovedAmount"
                                 [a-validation-messages]="[{ validationName: 'pattern', validationMessage: 'Pre-Approved Amount must be empty or more than zero and without decimals.' }]"
                                 a-formcontrol-type="number"
                                 id="preApprovedAmount">
                </app-formcontrol>
              </div>
            </div>

            <div class="row mb-4"
                 *ngIf="(availableDates$ | async) && leadForm.controls.branchId.valid">
              <div class="col-12 legend">Call me: (optional)</div>
              <div class="col-auto">
                <ngb-datepicker [class.is-invalid]="
                    (newMemberForm.controls.preferredDateTime.invalid && formSubmitted) ||
                    (newMemberForm.controls.preferredDateTime.dirty &&
                      newMemberForm.controls.preferredDateTime.invalid)
                  "
                                name="dp"
                                #dp
                                [minDate]="calendarService.getToday()"
                                [markDisabled]="isDateDisabled"
                                formControlName="preferredDateTime" />

                <div class="invalid-feedback"
                     *ngIf="
                    (newMemberForm.controls.preferredDateTime.invalid && formSubmitted) ||
                    (newMemberForm.controls.preferredDateTime.dirty &&
                      newMemberForm.controls.preferredDateTime.invalid)
                  ">
                  Invalid Date
                </div>
              </div>
              <div class="col-6 col-md-3"
                   *ngIf="availableTimes$ | async">
                <app-formselect [a-formcontrol]="leadForm.controls.newMember.controls.preferredTime"
                                a-formcontrol-name="preferredTime"
                                [a-validation-messages]="[
                    { validationName: 'required', validationMessage: 'Time range is require' }
                  ]">
                  <option value="">Select an time</option>
                  @for(item of availableTimes$ | async; track item.from){
                  <option [value]="item.from">{{ item.description }}</option>
                  }
                </app-formselect>
              </div>
            </div>
            <div class="row mb-4"
                 *ngIf="!(availableDates$ | async) && leadForm.controls.branchId.valid">
              <div class="col-12 legend">Preferred Date/Time to be contacted</div>

              <div class="alert alert-secondary">
                We currently do not have any appointment availability for the next 7 days for the
                selected branch. You can still submit this lead and we will assist the member as
                soon as possible. Thank you!
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-12">
                <hr />
                <h4>Vehicle Information <span class="text-danger">*</span></h4>
                <span>Please select one or more vehicle types that the member is interested in</span>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-12">
                <div class="d-flex">
                  <div class="form-check me-4">
                    <input formControlName="isVehicleTypeNew"
                           class="form-check-input"
                           type="checkbox"
                           id="newVehicle" />
                    <label class="form-check-label"
                           for="newVehicle">New Vehicle</label>
                  </div>
                  <div class="form-check me-4">
                    <input formControlName="isVehicleTypeUsed"
                           class="form-check-input"
                           type="checkbox"
                           id="usedVehicle" />
                    <label class="form-check-label"
                           for="usedVehicle">Used Vehicle</label>
                  </div>
                  <div class="form-check">
                    <input formControlName="isVehicleTypeTrade"
                           class="form-check-input"
                           type="checkbox"
                           id="tradeVehicle" />
                    <label class="form-check-label"
                           for="tradeVehicle">Trade Vehicle</label>
                  </div>


                  <!--<div class="invalid-feedback"
         *ngIf="leadForm.controls.newMember.controls.vehicleType.invalid">
      <div>Vehicle Type is required</div>
    </div>-->
                </div>                
                <div class="text-danger" *ngIf="showVehicleTypeError">
                  <i class="bi bi-exclamation-circle"></i> You must select at least one vehicle type.
                </div>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-12">
                <hr />
                <h4>Additional Notes</h4>
              </div>
              <div class="col-12">
                <textarea formControlName="notes"
                          placeholder="Interested vehicle details, budget amount, color options, preferred language etc.."
                          class="form-control form-control-sm form-control form-control-sm-sm"
                          maxlength="700"
                          rows="3"></textarea>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="showFormError">
            <div class="offset-8 col-4 alert alert-danger">
              There was an error submitting the form.
            </div>                
          </div>
          
          <div class="d-grid gap-2 d-md-flex justify-content-md-end">

            <button type="submit"
                    class="btn btn-primary px-4"
                    (click)="validateAddress()"
                    [hidden]="
                (newMemberForm.controls.isValidated.valueChanges | async) ||
                leadForm.controls.branchId.invalid || leadForm.controls.employeeId.invalid || newMemberForm.controls.address.invalid
              ">
              Validate Address
            </button>
            <button type="submit"
                    class="btn btn-primary px-4"
                    [disabled]="leadForm.invalid || submitting"
                    [hidden]="!newMemberForm.controls.isValidated">
              Submit
            </button>
            <button type="reset"
                    class="btn btn-outline-secondary px-4"
                    (click)="cancelRequest()">
              Reset
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
} @else{
<div
  class="container"
  style="margin-top: 80px"
>
  <div
    class="alert alert-danger"
    role="alert"
    [hidden]="employeeFormErrors.length == 0"
  >
    {{ employeeFormErrors[0] }}
  </div>
</div>
}
